// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"718d0d54","488":"b21b752e","796":"8e345eb7"}[chunkId] + ".chunk.js";
};